<template>
    <Badge lbl="mead.ai" :color="color" />
</template>

<script>
import Badge from "./Badge.vue";

/**
 * Small "AI" tag marking features powered by AI
 */
export default {
    name: "mead-ai-badge",
    components: { Badge },
    props: {
        /**
         * Color of the badge: a COLOR_STYLES value, a tint of one or any CSS color. Defaults to the
         * brand primary color
         */
        color: { type: String, default: "primary" },
    },
};
</script>
